const configApi = {
    URL_API: process.env.REACT_APP_URL_API || "https://webapi.laundry-you.com/api/",
    URL_NGAB: process.env.REACT_APP_URL_NGAB || "https://service.laundry-you.com/api",
};

export default configApi;
